<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="add-sensorgroup-modal">
<!-- <div class="modal-content add-sensorgroup-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Sensor Group:&nbsp;&nbsp; {{sensorGroupTitle}}</h5>
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
    </button>
  </div>
  <div class="modal-body" style="padding: 10px;">
    <div class="container-fluid">
      <div class="col-md-12">
        <form #sensorGroupEditor="ngForm" (ngSubmit)="updateSensorGroup(autoChartFavoritePickName)">

          <div style="padding-bottom: 20px; margin-right: 15px; display: flex; gap: 15px; align-items: stretch;">
            <div class="form-group col-md-4">
              <label for="sensorGroupName" style="font-weight: 500;">Name*</label>
              <input [(ngModel)]="sensorGroup.name" class="form-control" id="sensorGroupName" name="sensorGroupName"
                [style.color]="!duplicateName ? 'black' : 'red' " (ngModelChange)="duplicateNamecheck(sensorGroup.name)"
                required type="text" />
            </div>
            <div class="form-group col-md-8">
              <label for="description" style="font-weight: 500;">Description</label>
              <input [(ngModel)]="sensorGroup.description" class="form-control" id="description" name="description"
                required type="text" />
            </div>
          </div>

          <div style="padding-bottom: 20px; margin-right: 15px; display: flex; gap: 15px; align-items: stretch;">
            <div class="form-group  col-md-4">
              <label for="UserGroup" style="font-weight: 500;">Access Group*</label>
              <ngx-select-dropdown [(ngModel)]="selectedUserGroup" [config]="userGroupconfig"
                [options]="associatedUserGroups" name="userGroupSelection"></ngx-select-dropdown>
            </div>

            <div class="form-group col-md-4">
              <label for="plantdate" style="font-weight: 500;">Planting Date</label>
              <input type="datetime-local" id="plantDate" name="plantDate" class="form-control"
                [(ngModel)]="sensorGroup.plantDate" style="height: 36px; font-size: 15px;" (blur)="plantDateChanged()" required>

            </div>
            <div class="form-group" style="width: 320px;">
              <label for="crop" style="font-weight: 500;">Crop</label>
              <ngx-select-dropdown
                style="height: 35px;"
                [(ngModel)]="sensorGroup.crop"
                [config]="cropListconfig"
                [ngModelOptions]="{standalone: true}"
                [options]="crops">
              </ngx-select-dropdown>
            </div>
          </div>

          <div style="padding-top: 10px; padding-bottom: 25px; display: flex; gap: 5px; align-items: stretch;">
            <input type="checkbox" style="margin-top: -2px;" [(ngModel)]="createFavoriteChecked" name="createFavoriteChecked" />
            <span style="margin-left: 10px; margin-top: 5px; margin-right: 5px;">Create or update 7-day chart favorite using</span>

            <div style="width: 380px; margin-top: -3px;">
              <ng-multiselect-dropdown
                [placeholder]="'Select Sensor Reading Types'"
                [settings]="datatypeDropDownSettings"
                [data]="sensorDataTypes"
                [(ngModel)]="selectedSensorDataTypes"
                name="datatypes">
              </ng-multiselect-dropdown>
            </div>
          </div>

          <tabset>  
            <tab heading="Sensors" class="tabset">
              <div class="form-group">
                <ng-template #scanner class="qrScanner" let-modal>
                  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="qr-scanner-modal">
                  <!-- <div class="modal-content qr-scanner-modal"> -->
                    <div style="background-color: #548235;  height: 7px;"></div>
                    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">QR Code Scanner</h5>
                      <button
                        (click)="scanModalRef.hide()"
                        class="ms-auto fas fa-times"pe="button"
                        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                      </button>
                    </div>
                    <div class="modal-body qr-scanner-body">
                      <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner>
                      <br>
                      <!-- <div class="scanSensor" id="sensorUUID">{{scannedSensor}} </div> -->

                      <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 100%; border: 1px solid lightgray;">
                        <option value="" [selected]="!selectedDevice">No Device</option>
                        <option *ngFor="let device of availableDevices"
                            [value]="device.deviceId"
                            [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
                        </option>
                      </select>

                      <!-- <button (click)="addSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="margin-left: 10px; margin-top: -4px;">Add</button>
                      <button (click)="ignoreSensor()" [disabled]="scannedSensor === ''" class="btn btn-danger" id="ignoreButton" type="button" style="margin-left: 10px; margin-top: -4px;">Ignore</button> -->
                      
                      <div style="display: flex; gap: 15px;">
                        <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 0px; margin-top: 20px;" autofocus />
                        <button (click)="addSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px;">Add</button>
                        <button (click)="ignoreSensor()" [disabled]="scannedSensor === ''" class="btn btn-danger" id="ignoreButton" type="button" style="height: 35px; margin-top: 20px;">Ignore</button>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <p-table #uuidTable [columns]="sensorGroupUUIDCols" [scrollable]="true" [value]="sensorsDisplayed" scrollHeight="20em">
                  <ng-template pTemplate="caption">
                    <div style="text-align: left">

                      <form  (ngSubmit)="searchSensorsTextChanged()">
                        <label for="sensorGroupName" style="font-size: 17px; margin-left: -6px;">Sensors</label>
                        <i class="fa fa-search" style="margin:4px 4px 0 10px; cursor: pointer;" (click)="searchSensorsTextChanged()"></i>
                        <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
                        <input [(ngModel)]="sensorSearch" placeholder="Search" size="50" style="height: 38px; border: 1px solid lightgray; border-radius: 5px;" type="text" name="sensorSearch" autocomplete="off"/>
                        <button (click)="searchSensorsTextChanged()" class="btn btn-primary" style="margin-left: 10px; margin-top: -6px;" type="button">Search</button>
                        <button (click)="addAssociatedVirtualSensors()" class="btn btn-primary" style="margin-left: 10px; margin-top: -6px;" type="button">Show Internal Sensors</button>
                        <label style="margin-left: 15px; font-size: 14px; margin-top: -6px">Selected: {{ getCheckedSensorUUIDs() }} of {{allSensors.length}}</label>
                        <button (click)="openScanModal(scanner)" class="btn btn-warning" style="float: right; margin-left: 5px; margin-top: 0px;" type="button">Scan QR</button>
                      </form>
                    </div>
                  </ng-template>
                  <ng-template let-columns pTemplate="header">
                    <tr style="height: 40px;">
                      <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                    <tr style="height: 40px;">
                      <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        <p-checkbox
                          [(ngModel)]="rowData.checked" binary="true" id="{{rowData.uuid}}" name="{{rowData.uuid}}"
                          [ngModelOptions]="{standalone: true}"
                          (onChange)="sensorSelectionChanged(rowData)">
                        </p-checkbox>
                      </td>

                      <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.name }}
                      </td>

                      <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.uuid }}
                      </td>

                      <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.type }}
                      </td>

                      <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.lastReading.waitingForLoad">
                            <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                        </div>
                        <div *ngIf="!rowData.lastReading.waitingForLoad && rowData.lastReading.isLoaded" [ngStyle]="{'color': rowData.lastReading.displayColor }">
                            <i class="fa-solid fa-square"></i>
                            {{ rowData.lastReading.date | date: 'medium' }}
                        </div>
                      </td>

                      <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px; text-align: center;">
                        <div *ngIf="!rowData.ignoreShowOptions">
                          <div *ngIf="rowData.ignore" class="css-tooltip" [attr.tooltip-data]="rowData.ignoreUntil | date: 'medium'">
                            <p-checkbox
                              [(ngModel)]="rowData.ignore" binary="true" id="{{'IgnoreCheck1' + rowData.id}}" name="{{'IgnoreCheck1' + rowData.id}}"
                              [ngModelOptions]="{standalone: true}"
                              (onChange)="sensorIgnoreStateChanged(rowData)">
                            </p-checkbox>
                          </div>
                          <div *ngIf="!rowData.ignore">
                            <p-checkbox
                              [(ngModel)]="rowData.ignore" binary="true" id="{{'IgnoreCheck2' + rowData.id}}" name="{{'IgnoreCheck2' + rowData.id}}"
                              [ngModelOptions]="{standalone: true}"
                              (onChange)="sensorIgnoreStateChanged(rowData)">
                            </p-checkbox>
                          </div>
                        </div>

                        <div *ngIf="rowData.ignoreShowOptions">
                          <select name="{{'IgnoreOpt' + rowData.id}}" [(ngModel)]="rowData.ignoreDuration" style="height:30px; width: 65px; border-color: darkgray;" (ngModelChange)="sensorIgnoreDurationChanged(rowData)">
                            <option [value]="i" *ngFor="let i of sensorIgnoreDDOptions">{{i}}</option>
                          </select>
                        </div>

                      </td>

                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </tab>

            <tab heading="History" class="tabset">
              <div>
                <p-table [columns]="sensorGroupHistoryCols" [value]="sensorGroupHistory" dataKey="name" [scrollable]="true" scrollHeight="25em" >
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none; padding: 0.5rem;">
                        {{col.header}}
                      </th>
                    </tr>
                  </ng-template>
                  
                  <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                    <tr style="background-color: white;">
                      <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 8px;">
                        <div style="margin-bottom: 3px;">
                          {{ rowData.name }}
                        </div>
                        <div>
                          <label style="font-size: 13px; text-overflow: ellipsis; text-wrap: wrap; width: 100%">
                            {{ rowData.description }}
                          </label>
                        </div>
                      </td>

                      <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding: 8px;">
                        <div *ngIf="rowData.id > -1" style="margin-bottom: 3px; display: flex">
                          <label style="color: #548235; margin-right: 3px; margin-top: 3px;">S:</label>
                          <input
                            type="datetime-local" id="{{'starttime' + rowIndex}}" name="{{'starttime' + rowIndex}}" class="form-control"
                            [(ngModel)]="sensorGroupHistory[rowIndex].startDate" style="padding: 0px; border: none; font-size: 14px;"
                            (blur)="sensorGroupHistoryDatesChanged(rowData)"
                            required>
                        </div>
                        <div *ngIf="rowData.id > -1" style="margin-bottom: 3px; display: flex">
                          <label style="color: #548235; margin-right: 3px; margin-top: 3px;">E:</label> 
                          <input
                            type="datetime-local" id="{{'endtime' + rowIndex}}" name="{{'endtime' + rowIndex}}" class="form-control"
                            [(ngModel)]="sensorGroupHistory[rowIndex].endDate" style="padding: 0px; border: none; font-size: 14px;"
                            (blur)="sensorGroupHistoryDatesChanged(rowData)"
                            required>
                        </div>
                        <div  *ngIf="rowData.id < 1">
                          <div>
                            <label style="color: #548235; margin-right: 3px;">S:</label>
                            <label style="font-size: 14px;">{{ sensorGroupHistory[rowIndex].startDate | date : 'short' }}</label>
                          </div>
                          <div>
                            <label style="color: #548235; margin-right: 3px; margin-top: 7px;">E:</label>
                          </div>
                        </div>
                      </td>

                      <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px; padding: 8px;">
                        <div *ngFor="let sensor of rowData.sensors" style="margin-bottom: 3px;">
                          <div *ngIf="sensor.name == undefined || sensor.name.startsWith(' ')">-</div>
                          <div *ngIf="sensor.name != undefined && !sensor.name.startsWith(' ')">{{sensor.name}}</div>
                        </div>
                      </td>

                      <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px; padding: 8px;">
                        <div *ngFor="let sensor of rowData.sensors" style="margin-bottom: 3px;">{{sensor.uuid}}</div>
                      </td>

                      <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px; padding: 8px;">
                        <div *ngFor="let sensor of rowData.sensors" style="margin-bottom: 3px;">
                          <span class="fas fa-chart-line" (click)="showSensorDataPreview(sensor, rowData.startDate)" style="color:#1c4966; cursor: pointer; font-size: 14px;"></span>
                        </div>
                        
                      </td>
                      
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </tab>

            <tab heading="Associated Events & Actions" class="tabset">
              <div>
                <p-table [columns]="sensorGroupEventCols" [value]="sensorGroup.events" dataKey="name" [scrollable]="true" scrollHeight="25em" >
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                      </th>
                    </tr>
                  </ng-template>
                  
                  <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                    <tr>
                      <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.name }}
                      </td>

                      <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.isDisabled ? 'False' : 'True' }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>


            </tab>

          </tabset>

          <div *ngIf="sensorGroup.userFeatureAccess['EditSensorGroup']">
            <br>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
            <button class="btn btn-success col-xs-5 pull-right" type="submit" >{{modalMode}}</button>
            <button (click)="bsModalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 10px; margin-bottom: 20px;" type="button">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<ng-template #autoChartFavoritePickName>
  <div class="modal-content autoChartFavorite-modal">
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 style="color: rgb(10, 10, 10); text-transform: none;">Auto-Chart Favorite</h5>
      <button
        (click)="modalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
      </button>
    </div>
    <br>
    <div class="text-center" style="font-size: 18px;">
      <label style="margin-bottom: -5px;">Create or replace existing chart favorite</label><br>
      <label style="margin-bottom: 15px;">- overwrite or rename as needed -</label>
    </div>
    <table class="table" style="margin-left: 20px; border-collapse: separate; border-spacing: 10px;" >
      <tr>
        <td style="width: 70%">
          <input [(ngModel)]="newChartFavoriteName" style="width:100%; border-width: 1px; height: 37px;" name="newChartFavoriteName" required type="text" autofocus > 
        </td>
        <td style="width: 30%">
          <button (click)="createOrUpdateChartFavorite(undefined)" class="btn-sm" type="button" style="color:#64a70b; cursor: pointer; width: 90px; border-width: 1px; height: 38px;">Create</button>
        </td>
      </tr>
      <tr *ngFor="let favorite of associatedChartFavorites; let i = index">
        <td style="width: 70%">
          <!-- {{ favorite.name }} -->
          <input [(ngModel)]="favorite.name" style="width:100%; border-width: 1px; height: 37px;" name="favorite.name" required type="text" autofocus >
        </td>
        <td style="width: 30%">
          <button (click)="createOrUpdateChartFavorite(favorite)" class="btn-sm" type="button" style="color:#1c4966; cursor: pointer; width: 90px; border-width: 1px; height: 38px;">Replace</button>
        </td>
      </tr>
    </table>
    <br>
  </div>
</ng-template>